<template>
  <section class="article-head__menu">
    <!-- <button
      aria-label="查看更多操作"
      aria-controls="head-menu"
      aria-expanded="false"
      aria-haspopup="true"
      class="article-head__menu__button"
    >
      <span class="article-head__menu__dot"></span>
      <span class="article-head__menu__dot"></span>
      <span class="article-head__menu__dot"></span>
    </button>-->
    <nav id="head-menu" class="article-head__menu__nav">
      <button
        class="article-head__menu__control article-head__menu__control--share"
        @click="shareThisArticle"
        title="[另開新分頁]前往FB分享頁面"
        >分享</button
      >
      <button
        class="article-head__menu__control article-head__menu__control--like"
        @click="addFavorite"
        title="[跳轉頁面]收藏頁面"
        >收藏</button
      >
      <!-- 2019-12-02 因需求隱藏下載功能 -->
      <!-- <button class="a rticle-head__menu__control">下載</button> -->
    </nav>
  </section>
</template>

<script>
export default {
  name: 'ArticleHeadMenu',
  props: {
    referenceType: {
      type: Number,
      default: 0,
    },
    articleID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    isLogin() {
      return this.$store.getters.getLoginStatus;
    },
  },
  methods: {
    shareThisArticle() {
      const nowTimestamp = new Date().getTime();

      window.open(
        `http://www.facebook.com/sharer/sharer.php?u=${window.location.href}?${nowTimestamp}`
      );
    },
    addFavorite() {
      // 檢查有無登入
      if (!this.isLogin) {
        alert('請先登入，網頁跳轉中');
        return this.$router.push({
          name: 'login',
          query: { redirect: this.$route.path },
        });
      }
      const article = {
        reference_type: this.referenceType,
        reference_id: this.articleID,
      };
      this.$store
        .dispatch('addFavorite', article)
        .then(() => {
          window.alert('已成功收藏文章');
        })
        .catch((error) => {
          if (error.status === 401) {
            alert('請先登入，網頁跳轉中');
            return this.$router.push({
              name: 'login',
              query: { redirect: this.$route.path },
            });
          }
          alert('發生錯誤');
          throw error;
        });
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.article-head__menu {
  /* margin-top: 16px; // 讓它在圖鑑集相簿中被 collapsing */
  text-align: center;

  @include for-desktop {
    /* margin-left: 6px; */
    text-align: left;
  }

  &__button {
    @include button-theme(fake);
    padding: 0 10px;
    display: flex;
    position: absolute;
    top: 0;
    right: 10px;
    height: 45px;
    user-select: none;

    @include for-tablet {
      right: 10%;
    }

    @include for-desktop {
      display: none;
    }
  }

  &__dot {
    @include circle(4px);
  }

  @at-root &__dot + &__dot {
    margin-left: 4px;
  }

  &__control {
    @include button-theme(fake);
    background-size: contain;
    width: 129px;
    height: 40px;
    font-size: 0;
    color: $color-head-controls-bg;
    cursor: pointer;

    @include for-desktop {
      display: inline;
    }

    &--share {
      background-image: url('../../assets/images/header/btn-share.svg');
    }

    &--like {
      background-image: url('../../assets/images/header/btn-like.svg');
    }
  }

  &__control + &__control {
    margin-left: 10px;
  }
}
</style>
